import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCGhVbGNnFWvoP2FWdosHifphxawe6xXFs",
  authDomain: "cantavil.firebaseapp.com",
  projectId: "cantavil",
  storageBucket: "cantavil.firebasestorage.app",
  messagingSenderId: "118498989309",
  appId: "1:118498989309:web:d0550584668bbbdbaf9a94",
  measurementId: "G-T2X85CZW96"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Analytics (only in browser)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Initialize Firestore
const db = getFirestore(app)

// Initialize Auth
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

export { app, analytics, db, auth, googleProvider }
